import React from "react";
import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import httpService from "../../../services/http.service";
import "./settings.css";
import "../../navbar/adminNavbar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {

  Button,
} from "reactstrap";
import SuccessMessage from "../../common/successMsg";
import Navbar from './settingNav';
import ErrorMessage from "../../common/errorMsg";
import WarningMessage from "../../common/warnMsg";

const CloudCredentials = (props) => {
  const [activeTab, setActiveTab] = useState("cloudcredentials");

  const [save, setSave] = useState(true);
  const [clientModelId, setclientModelId] = useState('');
  const [onClickData, setOnclickData] = useState({});

  useEffect(() => {
    loadClientIdData();
    showIdfunction();
  }, []);
  const onInputChange = (e) => {
    setOnclickData({ ...onClickData, [e.target.name]: e.target.value });
  };



  const setClientIdForClient = async () => {
    if(!onClickData.GoogleDriveClientId&&!onClickData.GoogleDriveKey&&!onClickData.weatherApiKey&&!onClickData.DropboxKey){
      WarningMessage("Please Enter the Key And Id")
      return;
    }
    let data = {
      data: onClickData,
    };
    const res = await httpService
      .CreateUpdate("setClientIdApi", data)
      .catch((err) => {
        return;
      });
    setSave(false)
    loadClientIdData();

    if (res.data.message == "Successful") {
      SuccessMessage("Client Id's has been Saved ")
    }

  }

  const updateClientIdForClient = async () => {
  //  console.log(onClickData,"onClickData")
    if(!onClickData.GoogleDriveClientId&&!onClickData.GoogleDriveKey&&!onClickData.weatherApiKey&&!onClickData.DropboxKey){
      WarningMessage("Please Enter the Key And Id")
      return;
    }
    let data = {
      id: clientModelId._id,
      data: onClickData,
    };
    const res = await httpService
      .CreateUpdate("updateClientIdForClient", data)
      .catch((err) => {
        return;
      });

    if (res.data.message == "Successful") {
      SuccessMessage("Client Id's has been Updated successfully")
    }
  }

  const showIdfunction = () => {
    if (clientModelId.GoogleDriveClientId || clientModelId.GoogleDriveKey || clientModelId.DropboxKey || clientModelId.weatherApiKey) {
      setSave(false);
    }
  };

  const setIdfunction = () => {

  };

  const loadClientIdData = async () => {
    const res = await httpService
      .CreateUpdate("getClientIdData")
      .catch((err) => {
        if (err && err.response && err.response.status == 401) {
          ErrorMessage("Session expired, please login again")
        }
        return;
      });
    if (res.data[0]) {
      setclientModelId(res.data[0])
      setOnclickData(res.data[0])
    }
  };

  return (
    <div style={{ margin: "15px" }}>
       <Navbar activeTab={activeTab} />
       <div className='pad-15 mt-5'>
      <div className="ui main">
        <form className="ui form ">
          <div className="field row">
            <div className="field  col-6">
              <label>Google Drive Client Id</label>
              <input
                type="text"
                className="form-control"
                name="GoogleDriveClientId"
                placeholder="Google Drive Client Id"
                onChange={(e) => onInputChange(e)}
                value={onClickData.GoogleDriveClientId}
              />
              {onClickData.GoogleDriveClientId ? "" : <span style={{ color: "red" }}>Please Enter the Google Drive Client Id for using Drive selection !</span>}

            </div>
            <div className="col-6"></div>

            <div className="field col-6">
              <label>Google Drive Key</label>
              <input
                type="text"
                className="form-control"
                name="GoogleDriveKey"
                placeholder="Google Drive Key"
                onChange={(e) => onInputChange(e)}
                value={onClickData.GoogleDriveKey}
              />
              {onClickData.GoogleDriveKey ? "" : <span style={{ color: "red" }}>Please Enter the Google Drive Key for using Drive selection !</span>}

            </div>
            <div className="col-6"></div>

            <div className="field col-6">
              <label>Dropbox Key</label>
              <input
                type="text"
                name="DropboxKey"
                className="form-control"
                placeholder="Dropbox Key"
                onChange={(e) => onInputChange(e)}
                value={onClickData.DropboxKey}
              />
              {onClickData.DropboxKey ? "" : <span style={{ color: "red" }}>Please Enter the Dropbox App Key for using Dropbox selection !</span>}
            </div>
            <div className="col-6"></div>
            <div className="field col-6">
                  <label>Dropbox Secret</label>
                  <input
                    type="text"
                    name="DropboxSecret"
                    placeholder="Dropbox Secret"
                    onChange={(e) => onInputChange(e)}
                    value={onClickData.DropboxSecret}
                  />
                  {onClickData.DropboxSecret ? "" : <span style={{ color: "red" }}>Please Enter the Dropbox App Secret for using User's Dropbox Access Permission !</span>}
            </div>
            <div className="col-6"></div>

            <div className="field col-6">
              <label>Weather API Key</label>
              <input
                type="text"
                className="form-control"
                name="weatherApiKey"
                placeholder="Weather API Key"
                onChange={(e) => onInputChange(e)}
                value={onClickData.weatherApiKey}
              />
              {onClickData.weatherApiKey ? "" : <span style={{ color: "red" }}>Please Enter the weather Api Key for using weather widget !</span>}
            </div>
          </div>

        </form>
      </div>
      </div>
      <div className="col-6"></div>
      <div className="text-end col-6" style={{ marginTop: "15px" }}>
        <Button
          color="success"
          style={{ marginRight: "5px" }}

          onClick={() => {

            if (save) { setClientIdForClient(); }
            else {
              updateClientIdForClient();
            }


          }}
        >
          save
        </Button>
        {/* <Button
          color="danger"
          onClick={() => {

            setIdfunction();


          }}
        >
          Cancel
        </Button> */}
      </div>
    </div>
  );
};

export default CloudCredentials;
